"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _info = _interopRequireDefault(require("./info"));

var _task_component = _interopRequireDefault(require("./component/task_component"));

var _status_component = _interopRequireDefault(require("./component/status_component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Task =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Task, _PureComponent);

  function Task() {
    _classCallCheck(this, Task);

    return _possibleConstructorReturn(this, _getPrototypeOf(Task).apply(this, arguments));
  }

  _createClass(Task, [{
    key: "componentDidMount",

    /**
     * 组件属性说明
     * @alias TaskProps
     * @description 引导用户按照流程完成任务的列表。
     * @property {titleline} 默认支持参数
     * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
     * @property {titleline} 基础属性
     * @property {array} data=[]] 任务数据
     * @property {array} done=[]] 已经处理的任务id
     * @property {string|number} [doing=''] 目前正在处理的任务id
     * @property {string|number} [active=''] 目前激活中的任务id
     * @property {func} [onClick] 点击回调
     * @property {func|element} [TaskComponent] 子任务组件结构
     * @property {func|element} [StatusComponent] 状态组件结构
     * @example
     * data = [{
            title: '填写基本信息',                      // 一级任务标题
            list: [{                                   // 子任务
                href: '#',                             // 任务页面锚点
                id: 'info_a'                           // 通过id来标识任务，唯一
                label: '设置权限组的范围和名称1'         // 任务名称
            }, {
                id: 'info_b'
                label: '设置权限组的范围和名称2'
            }]
        }, {
            title: '设置关注人',
            list: [{
                href: '#',
                id: 'guanzhuren_a'
                label: '设置该权限组下的关注人'
            }]
        }];
     *
     *&lt;TaskComponent
    {...this.props}
    data={subItem}
    onClick={(event) => {}}
    href={href}
    label={label}
    statusClassName={statusClassName}
    /&gt;
     *
     * &lt;StatusComponent
    {...this.props}
    /&gt;
     *
     */
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "isAction",
    value: function isAction() {
      var listData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var actionId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var result = false;
      listData.map(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _item$id = item.id,
            id = _item$id === void 0 ? '' : _item$id;

        if (!result && actionId && id === actionId) {
          result = true;
        }

        return item;
      });
      return result;
    }
  }, {
    key: "isDone",
    value: function isDone() {
      var listData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _this$props$done = this.props.done,
          done = _this$props$done === void 0 ? [] : _this$props$done;
      var result = true;

      if (listData.length > 0) {
        listData.map(function () {
          var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var id = item.id;

          if ((0, _spauiUtils.indexOf)(done, id) < 0) {
            result = false;
          }

          return item;
        });
      } else {
        result = false;
      }

      return result;
    } // 是否只有一层任务，没有list任务

  }, {
    key: "isOneLevelData",
    value: function isOneLevelData() {
      var _this$props$data = this.props.data,
          data = _this$props$data === void 0 ? [] : _this$props$data;
      var result = true;
      data.map(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (item && item.list && item.list.length > 0) {
          result = false;
        }

        return item;
      });
      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          data = _this$props.data,
          done = _this$props.done,
          doing = _this$props.doing,
          active = _this$props.active,
          TaskComponent = _this$props.TaskComponent,
          StatusComponent = _this$props.StatusComponent,
          _onClick = _this$props.onClick;
      return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])('spaui-task', {
          'spaui-task-single': this.isOneLevelData()
        })
      }, Task), data.map(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var index = arguments.length > 1 ? arguments[1] : undefined;
        var _item$title = item.title,
            title = _item$title === void 0 ? '' : _item$title,
            _item$list = item.list,
            list = _item$list === void 0 ? [] : _item$list,
            _item$id2 = item.id,
            itemId = _item$id2 === void 0 ? '' : _item$id2;
        var isDone = _this.isDone(list) || (0, _spauiUtils.indexOf)(done, itemId) > -1;
        var isDoing = (_this.isAction(list, doing) || itemId === doing) && !isDone;
        var isActive = _this.isAction(list, active) || itemId === active;
        var itemClassName = (0, _classnames["default"])('spaui-task-item', {
          done: isDone,
          doing: isDoing,
          active: isActive || isDoing
        });
        return _react["default"].createElement("div", {
          className: itemClassName,
          key: index
        }, _react["default"].createElement("p", {
          className: "spaui-task-title",
          onClick: function onClick(event) {
            return _onClick(event, item);
          }
        }, title, _react["default"].createElement(StatusComponent, _extends({}, _this.props, {
          StatusComponent: null
        }))), list.length > 0 ? _react["default"].createElement("ul", {
          className: "spaui-task-list"
        }, list.map(function () {
          var subItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var subIndex = arguments.length > 1 ? arguments[1] : undefined;
          var href = subItem.href,
              _subItem$label = subItem.label,
              label = _subItem$label === void 0 ? '' : _subItem$label,
              _subItem$id = subItem.id,
              id = _subItem$id === void 0 ? '' : _subItem$id;
          var isSubItemDone = (0, _spauiUtils.indexOf)(done, id) > -1;
          var isSubItemDoing = id === doing && !isSubItemDone;
          var isSubItemActive = id === active;
          var statusClassName = (0, _classnames["default"])({
            done: isSubItemDone,
            doing: isSubItemDoing,
            active: isSubItemActive || isSubItemDoing
          });
          return _react["default"].createElement(TaskComponent, _extends({}, _this.props, {
            TaskComponent: null,
            key: subIndex,
            data: subItem,
            onClick: function onClick(event) {
              return _onClick(event, subItem);
            },
            href: href,
            label: label,
            statusClassName: statusClassName
          }));
        })) : null);
      }));
    }
  }]);

  return Task;
}(_react.PureComponent); // 组件标记


_defineProperty(Task, "propTypes", {
  data: _spauiUtils.PropTypes.array.isRequired,
  done: _spauiUtils.PropTypes.array,
  doing: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.string, _spauiUtils.PropTypes.number]),
  active: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.string, _spauiUtils.PropTypes.number]),
  onClick: _spauiUtils.PropTypes.func,
  TaskComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  StatusComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element])
});

_defineProperty(Task, "defaultProps", {
  data: [],
  done: [],
  doing: '',
  active: '',
  onClick: _spauiUtils.noop,
  TaskComponent: _task_component["default"],
  StatusComponent: _status_component["default"]
});

(0, _spauiUtils.setComponentMark)(Task, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Task;
exports["default"] = _default;